// extracted by mini-css-extract-plugin
export default {"map":"map-NPEfI","loadingWheel":"loadingWheel-_t7bQ"};